import * as Yup from 'yup'

export const serviceProviderSchema = Yup.object({
   name: Yup.string().trim().required('Name is required'),

   email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),

   countryCode: Yup.string()
      .required('Country code is required')
      .matches(/^\+\d{1,3}$/, 'Invalid country code'),

   phoneNumber: Yup.string()
      .required('Phone number is required')
      .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
      .min(10, "Phone number should be atmost 10 characters long"),

   address: Yup.string().trim().required('Address is required'),

   status: Yup.boolean().required('Status is required'),
})
